module.exports = "/build/admin/images/apple-touch-icon-57x57.92fc78a5.png";